import { render } from "./GridCardsServicos.vue?vue&type=template&id=1b3f352c&scoped=true"
import script from "./GridCardsServicos.vue?vue&type=script&lang=js"
export * from "./GridCardsServicos.vue?vue&type=script&lang=js"

import "./GridCardsServicos.vue?vue&type=style&index=0&id=1b3f352c&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3f352c"]])

export default __exports__